import React from 'react';
import RootGameOdds from './RootGameOdds';
import ViewCard from '../components/ViewCard';
import ViewOddsGroup from '../components/ViewOddsGroup';

export default class GameRestOdds extends RootGameOdds {
    render() {
        if (this.props.groups) {
            const groups = this.props.groups;

            if (groups) {
                return (
                    <ViewCard
                        label={
                            this.props.label
                                ? this.props.label
                                : groups[0].marketTypeGroupName
                        }
                        opened={this.props.opened ? 'yes' : 'no'}
                        stateHandler={this.props.stateHandler}
                    >
                        <div
                            className={
                                groups[0] &&
                                groups[0].marketTypeGroupName &&
                                groups[0].marketTypeGroupName
                                    .toLowerCase()
                                    .indexOf('spiller specials') > -1
                                    ? 'p10 small-size-odds'
                                    : 'p10'
                            }
                        >
                            <ViewOddsGroup data={groups} />
                        </div>
                    </ViewCard>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
